import React from "react";
import { motion } from "framer-motion";

const BulkUploadSuccessModal = ({ onClose, onViewContracts }) => {
  const handleViewContracts = () => {
    onViewContracts();
  };

  return (
    <motion.div
      className="fixed inset-0 z-[1000] bg-black bg-opacity-40 flex items-center justify-center px-fluid-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-white rounded-2xl shadow-xl w-full max-w-3xl p-fluid-4 space-y-fluid-4"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.95 }}
      >
        {/* Big Icon with Tick Animation */}
        <div className="flex flex-col items-center space-y-fluid-1.5">
          <div className="bg-green-100 rounded-full p-fluid-3">
            <motion.svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#16a34a"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-fluid-icon-md h-fluid-icon-md"
            >
              <motion.path
                d="M20 6L9 17L4 12"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
              />
            </motion.svg>
          </div>

          <h2 className="text-fluid-xl font-semibold text-center text-[#111827]">
            All contracts uploaded successfully
          </h2>

          <p className="text-fluid-base text-gray-600 text-center max-w-xl">
            You have approved the bill of lading for shipment. The carrier
            associated with this shipment will receive a notification.
          </p>
        </div>

        {/* Footer with Actions */}
        <div className="flex flex-col items-center gap-fluid-3">
          <div className="flex gap-fluid-2">
            <button
              onClick={handleViewContracts}
              className="px-fluid-button-x py-fluid-button-y bg-custom-bg-blue text-white hover:bg-[#1a2a61] text-fluid-sm rounded font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              View Contracts
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default BulkUploadSuccessModal;
